export default __webpack_public_path__ + "static/media/bar-chart.fbe6bba3.png";